import $ from 'jquery';

$(document).ready(function() {
  // open date select

  $('.date-select .mailing__form-input').on('click', e => {
    e.stopPropagation();
    let $this = $(e.currentTarget);

    $this.closest('.date-select').toggleClass('active');
  });

  // choose date

  $(window).on('click', e => {
    if (!$('.select-list-wrapper').is(e.target)) {
      $('.date-select').removeClass('active');
    }
  });

  $('.select-list-item').on('click', function() {
    let $value = $(this).text();
    console.log($value);

    $(this)
      .closest('.select-list-row')
      .siblings()
      .removeClass('selected');

    $(this)
      .closest('.select-list-row')
      .addClass('selected');

    $(this)
      .closest('.date-select')
      .removeClass('active');

    if ($('.subs-entry').length > 0) {
      if ($(this).attr('data-val')) {
        let $subsValue = $(this).attr('data-val');
        $('.hide-input-value[name="subscribe_from"]').val($subsValue);
      }

      $(this)
        .closest('.date-select')
        .find('.mailing__form-input')
        .val($value);
    }
  });
});
